import React from 'react'

export default function Footer() {
    return (
        <div className="container bottom d-flex justify-content-center align-items-center">
		   <footer>
	            <p>Rishabh Sahejpal Designs &copy;. All rights reserved.</p>
	        </footer>
		</div>
    )
}
